<template>
  <div class="hot-body">
    <div class="hotcontent-banner"></div>
    <div class="container">
      <div class="news-content">
        <p style="padding: .39rem .24rem; font-size: .4rem; font-weight: bold;">{{hotList.title}}</p>
        <div class="news-nav">
          <div class="line"></div>
          <div class="news-titleInfo"><span>作者:{{hotList.writer}}</span><span style="margin-left: .40rem;">{{hotList.create_time}}</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="news-nr" v-html="hotList.article"></div>
        <div class="line"></div>

        <div  @click="clickShare" style="display: flex;justify-content: flex-end;margin: .2rem .2rem; align-items: center;">
          <svg class="icon navBtn share" aria-hidden="true">
            <use xlink:href="#icon-fenxiang1"></use>
          </svg>
          <p>分享</p>
        </div>

      </div>
    </div>
    <shareTips v-show="showDialog" :dialog-option="dialogOption" ref="Alert"></shareTips>
  </div>
</template>

<script>
  import shareTips from './shareTips'
  import shareM from './shareM'

  export default {
    name: "Hot",
    data() {
      return {
        isRouterAlive: true,
        hotList: [],
        showDialog: false,
        dialogOption:{
          // title: '映派提示',
          text: ''
        }
      }
    },
    metaInfo() {
      return {
        title: this.hotList.title|| '',
        meta: [{
          name: 'keywords',
          content: this.hotList.keywords|| ''
        }, {
          name: 'description',
          content: this.hotList.description|| ''
        }]
      }
    },
    methods: {
      clickShare(){
        this.showDialog = true
        this.initAlert()
      },
      getHotListData() {
        let hotApi = `https://api.yopoo.cn/api/v1/minutenew?id=${this.$route.params.id}`
        this.$http.get(hotApi).then(res => {
          this.hotList = res.data.data
        }, err => {
          console.log(err)
        })
      },
      initAlert(){
        this.showDialog = true;
        this.$refs.Alert.confirm().then(() => {
          this.showDialog = false;
        }).catch(() => {
          this.showDialog = false;
        })
      },
    }
    ,
    components: {
      shareTips
    }
    ,
    beforeMount() {
      this.getHotListData()

    }
    ,
    mounted() {
    }
    ,
    created() {

    }
    ,
    beforeDestroy() {
    }
    ,
    // beforeRouteEnter (to, from, next) {
    //   // location.reload()
    // },

  }
</script>

<style scoped>

  .hot-body {
    background: #fff;
    padding-bottom: .15rem;
    font-size: .3rem;
  }

  .hotcontent-banner {
    background: url(http://yopoo.oss-cn-beijing.aliyuncs.com/bg-news.jpg) no-repeat;
    background-size: 100% 100%;
    height: 2.8rem;
  }

  .line {
    height: .01rem; /*rem*/
    background: rgba(179, 179, 179, 1);
    margin: 0 .24rem;
  }

  .news-titleInfo {
    margin: .19rem .24rem;
    font-size: .25rem; /*rem*/
    color: rgba(102, 102, 102, 1);
  }

  .news-nr {
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    /*align-items: center;*/
    /*font-size: .3rem!important; !*no*!*/
    line-height: 1.5;
    margin: .39rem .23rem .39rem .23rem;
  }




  .share{
    color: gray;
    width: .35rem;
    height: .35rem;
    margin-right: .1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/Hot.vue